import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=16000af5&scoped=true&"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=16000af5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16000af5",
  null
  
)

export default component.exports